class OMLVideoComponent {
    constructor(index, element) {
        this.$index = index;
        this.$element = $(element)
        this.init();
    }
    init(){
      console.log("this.$element", this.$element)
        this.$video = this.$element.find("video");
        this.$video.on("play", this.__handleVideoPlay.bind(this));
        this.$video.on("pause", this.__handleVideoPause.bind(this));

        this.$video.on("click", this.__handleVideoClick.bind(this))
    }

    __handleVideoPlay(e){
        this.$element.toggleClass("is-playing", !e.currentTarget.paused);
    }

    __handleVideoPause(e){
        this.$element.toggleClass("is-playing", !e.currentTarget.paused)
    }

    __handleVideoClick(e){
        if (e.currentTarget.paused){
            e.currentTarget.play()
        }else {
            e.currentTarget.pause()
        }
    }
}

class OMLDraggableObjects {
    constructor(t, e) {
        (this.$index = t), (this.$element = $(e)), (this.selectors = { testimony: ".floating-testimonials__image", wrapper: ".floating-testimonials", sectionContent: ".section-title, .section-text, .button-set" }), this.init();
    }
    init() {
        (this.$testimony = this.$element.find(this.selectors.testimony)), (this.$wrapper = this.$element.find(this.selectors.wrapper)), (this.$sectionContent = this.$element.find(this.selectors.sectionContent));
        const t = $(window).width();
        $(window).on("resize", () => {
            $(window).width() != t && this.initializeFloatingElements;
        }),
            this.initializeFloatingElements();
    }
    initializeFloatingElements() {
        this.$testimony.each((t, e) => gsap.set($(e), { rotate: `${Math.floor(15 * Math.random() - 7)}deg` })), $(window).width() <= 639 || this.initDrag();
    }
    initDrag() {
        this.initGrabCursor(),
            interact(`#${this.$element.attr("id")} ${this.selectors.testimony}`).draggable({
                inertia: !0,
                modifiers: [interact.modifiers.restrictRect({ restriction: "parent", endOnly: !0 })],
                autoScroll: !1,
                listeners: { move: this.dragMoveListener, end(t) {} },
            }),
            (window.dragMoveListener = this.dragMoveListener);
    }
    dragMoveListener(t) {
        var e = t.target,
            i = (parseFloat(e.getAttribute("data-x")) || 0) + t.dx,
            s = (parseFloat(e.getAttribute("data-y")) || 0) + t.dy;
        gsap.set($(e), { x: i, y: s }), e.setAttribute("data-x", i), e.setAttribute("data-y", s);
    }
    initGrabCursor() {
        this.$testimony.on("mousedown", (t) => $(t.currentTarget).addClass("grabbing")), this.$testimony.on("mouseup", (t) => $(t.currentTarget).removeClass("grabbing"));
    }
}

// After Bae

class RecipeMakerInit {
    constructor(t, e) {
        (this.$index = t),
            (this.$element = $(e)),
            (this.selectors = { inner: ".after-bae__inner", ingredient: ".after-bae__ingredient" }),
            (this.minimumDropped = this.$element.data("animate-after")),
            (this.animationDuration = 1e3 * this.$element.css("--after-bae-transition-duration").replace("s", "")),
            (this.explosionGIFUrl = this.$element.data("explosion")),
            this.init();
    }
    init() {
        (this.$ingredient = this.$element.find(this.selectors.ingredient)),
            (this.$inner = this.$element.find(this.selectors.inner)),
            (this.$wrapper = this.$element),
            (window.afterBaeAnimate = this.animateAfterBae.bind(this)),
            (window.initIngredientsPosition = this.initIngredientsPosition.bind(this)),
            this.initDrag();
    }
    animateAfterBae() {
        this.$element.removeClass("mixed"),
            this.$element.addClass("mixing"),
            setTimeout(() => {
                this.$element.addClass("mixed").removeClass("mixing");
            }, this.animationDuration - 100);
    }
    initIngredientsPosition() {
        const t = this.$wrapper,
            e = this.$ingredient,
            i = this.$inner,
            s = t.width(),
            n = t.height(),
            r = [0.5, 0.75, 1],
            a = (Math.floor(3 * Math.random() + 0), []);
        e.each(function () {
            const t2 = $(this),
                e2 = t2.width(),
                o = t2.height();
            let d, l, h, c;
            const m = r[Math.floor(3 * Math.random() + 0)];
            do {
                (d = Math.random() * (s - e2)), (l = Math.random() * (n - o));
                const t3 = { left: d, top: l, right: d + e2, bottom: l + o };
                (h = i.toArray().some(function (e3) {
                    var i2 = e3.getBoundingClientRect();
                    return !(t3.right < i2.left || t3.left > i2.right || t3.bottom < i2.top || t3.top > i2.bottom);
                })),
                    (c = a.some(function (e3) {
                        return !(t3.right < e3.left || t3.left > e3.right || t3.bottom < e3.top || t3.top > e3.bottom);
                    }));
            } while (h || c);
            a.push({ left: d, top: l, right: d + e2, bottom: l + o }), gsap.to(t2, { left: d, top: l, transform: "unset", scrollTrigger: { trigger: this.$element, start: "top 25%" } }), gsap.to(t2.find("img"), { scale: m });
        }),
            this.initDrag();
    }
    initDrag() {
        this.initGrabCursor(),
            this.initDropZone(),
            interact(`#${this.$element.attr("id")} ${this.selectors.ingredient}`).draggable({
                inertia: !0,
                modifiers: [interact.modifiers.restrictRect({ restriction: "parent", endOnly: !0 })],
                autoScroll: !1,
                listeners: { move: this.dragMoveListener, end(t) {} },
            }),
            (window.dragMoveListener = this.dragMoveListener);
    }
    dragMoveListener(t) {
        var e = t.target,
            i = (parseFloat(e.getAttribute("data-x")) || 0) + t.dx,
            s = (parseFloat(e.getAttribute("data-y")) || 0) + t.dy;
        gsap.set($(e), { x: i, y: s }), e.setAttribute("data-x", i), e.setAttribute("data-y", s);
    }
    initDropZone() {
        interact(`#${this.$element.attr("id")} ${this.selectors.inner}`).dropzone({
            accept: `#${this.$element.attr("id")} ${this.selectors.ingredient}`,
            overlap: 0.75,
            ondropactivate: function (t) {},
            ondragenter: function (t) {},
            ondragleave: function (t) {},
            ondrop: (t) => {
                const e = $(t.relatedTarget);
                e.addClass("dropped"),
                    e.find(".explosion").addClass("play"),
                    setTimeout(() => {
                        e.find(".explosion").addClass("played"),
                            $(`#${this.$element.attr("id")} ${this.selectors.ingredient}.dropped`).length >= this.minimumDropped && (this.$ingredient.addClass("not-draggable").css("pointer-events", "none"), this.animateAfterBae());
                    }, 1e3);
            },
            ondropdeactivate: function (t) {},
        });
    }
    disableAllIngredient() {
        $(`#${this.$element.attr("id")} ${this.selectors.ingredient}.dropped`);
    }
    initGrabCursor() {
        this.$ingredient.on("mousedown", (t) => $(t.currentTarget).addClass("grabbing")), this.$ingredient.on("mouseup", (t) => $(t.currentTarget).removeClass("grabbing"));
    }
}

// Floating Ingredients

class OMLFloatingIngredients {
    constructor(t, e) {
        (this.$index = t), (this.$element = $(e)), (this.selectors = { ingredient: ".accent-graphic" }), this.init();
    }
    init() {
        (this.$ingredient = this.$element.find(this.selectors.ingredient)), this.initIngredients(), this.setDimensions();
    }
    setDimensions() {
        const t = this.$element.closest("section").find(".section-content"),
            e = new ResizeObserver(() => {
                this.$element.height(t.innerHeight());
            });
        this.$element.height(t.innerHeight()), e.observe(t.get(0));
    }
    initIngredients() {
        this.initScrollingAnimation();
    }
    initScrollingAnimation() {

        const t = gsap.timeline({ reverse: true, scrollTrigger: { trigger: this.$element, start: `top ${$(".section-header-navigation").height()}`, end: `bottom ${$(".section-header-navigation").height()}`, scrub: true } });
        this.$ingredient.each((e, i) => {
            const s = $(window).width() <= 1023 ? this.getRandomValue(25, 50) : this.getRandomValue(35, 58),
                n = $(window).width() <= 1023 ? "35px" : "57px";
            this.getElementPosition($(i)) == "left" ? t.to($(i), { right: "unset", left: `${s}%` }, "<") : t.to($(i), { left: "unset", right: `${s}%` }, "<"), t.to($(i), { top: "unset", bottom: n }, "<");
        }),
            t.to(this.$ingredient, { bottom: "0px" }, ">");
    }
    getRandomValue(t, e) {
        return Math.floor(Math.random() * (e - t + 1) + t);
    }
    getElementPosition(t) {
        var e = $(window).width();
        return t.offset().left + t.outerWidth() / 2 < e / 2 ? "left" : "right";
    }
}

class OMLHeroComponents {
    constructor(t, e) {
        (this.$index = t),
            (this.$element = $(e)),
            (this.selectors = {}),
            (this.maxBorderRadius = 30),
            (this.minScale = 0.96),
            (this.topTriggers = { start: "top 80%", end: "top 10%" }),
            (this.bottomTriggers = { start: "bottom 80%", end: "bottom 10%" }),
            this.init();
    }
    init() {
        gsap.set(this.$element, { borderTopLeftRadius: this.maxBorderRadius, borderTopRightRadius: this.maxBorderRadius, borderBottomLeftRadius: 0, borderBottomRightRadius: 0, scaleX: this.minScale }),
            gsap.fromTo(
                this.$element,
                { scaleX: 1 },
                { borderBottomLeftRadius: this.maxBorderRadius, borderBottomRightRadius: this.maxBorderRadius, scaleX: this.minScale, scrollTrigger: { trigger: this.$element, scrub: !0, ...this.bottomTriggers } }
            ),
            gsap.fromTo(this.$element, { scaleX: this.minScale }, { borderTopLeftRadius: 0, borderTopRightRadius: 0, scaleX: 1, scrollTrigger: { trigger: this.$element, scrub: !0, ...this.topTriggers } });
    }
}

